<template>
  <div class="panel">
    <div class="headerPanel">
      <HeaderPanel />
    </div>
    <div class="navbarPanel">
      <NavbarPanel />
    </div>
    <div class="mainCatalogs">
      <template>
        <v-treeview
          v-model="tree"
          :open="initiallyOpen"
          :items="items"
          activatable
          item-key="name"
          open-on-click
        >
          <template v-slot:prepend="{ item, open }">
            <v-icon v-if="!item.file">
              {{ open ? "mdi-folder-open" : "mdi-folder" }}
            </v-icon>
            <v-icon
              v-else
              @click="
                item.link
                  ? abrirJanela(`${item.link}/${item.name}.${item.file}`)
                  : true
              "
            >
              {{ files[item.file] }}
            </v-icon>
          </template>
        </v-treeview>
      </template>
    </div>
  </div>
</template>

<script>
import HeaderPanel from "@/components/panel/HeaderPanel";
import NavbarPanel from "@/components/panel/NavbarPanel";

export default {
  data() {
    return {
      linkDaPagina: null,
      baseUrlDownload:
        "https://www.leverosintegra.com.br/download/5 - Central de Downloads/",
      initiallyOpen: ["public"],
      files: {
        html: "mdi-language-html5",
        js: "mdi-nodejs",
        json: "mdi-code-json",
        md: "mdi-language-markdown",
        pdf: "mdi-file-pdf-box",
        pdf2: "mdi-file-pdf-box",
        png: "mdi-file-image",
        jpeg: "mdi-file-image",
        txt: "mdi-file-document-outline",
        xls: "mdi-file-excel",
		    mp4: "mdi-video",
        mov: "mdi-video",
      },
      tree: [],
      items: [
        {
          name: "1. Datasheets",
          children: [
            {
              name: "Canadian - Inversores",
              children: [
                {
                  name: "1 - Datasheet (3.0-5.0) kW",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
                {
                  name: "2 - Datasheet (7.0-9.0) kW",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
                {
                  name: "3 - Datasheet (15-20) kW",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
                {
                  name: "4 - Datasheet (25-30-40) kW",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
                {
                  name: "5 - Datasheet  (20-25-30) kW -LV",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
                {
                  name: "6 - Datasheet 75 kW",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
                {
                  name: "Termo de garantia Canadian Solar",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Inversores/",
                },
              ],
            },
            {
              name: "Canadian - Módulos",
              children: [
                {
                  name: "1. 540W-545W-550W - 30mm",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Módulos/",
                },
                {
                  name: "2. 540W-545W-550W - 35mm",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Módulos/",
                },
                {
                  name: "Termo-de-Garantia-Canadian-Solar-em-portugues",
                  file: "pdf",
                  link: "1. Datasheets/Canadian - Módulos/",
                },
              ],
            },
            {
              name: "Clamper",
              children: [
                {
                  name: "1 - QFV CC - 1E-1S - 1000V",
                  file: "pdf",
                  link: "1. Datasheets/Clamper/",
                },
                {
                  name: "2 - QFV CC - 2-4E-2-4S - 1000V",
                  file: "pdf",
                  link: "1. Datasheets/Clamper/",
                },
                {
                  name: "2 - QFV CC - 2E-2S - 1000V",
                  file: "pdf",
                  link: "1. Datasheets/Clamper/",
                },
                {
                  name: "3 - QFV CC - 3E-3S - 1000V",
                  file: "pdf",
                  link: "1. Datasheets/Clamper/",
                },
              ],
            },
            {
              name: "DEYE",
              children: [
                {
                  name: "1. Datasheet DEYE - Micro 2000-G3-US-220",
                  file: "pdf",
                  link: "1. Datasheets/DEYE/",
                },
              ],
            },
            {
              name: "Hypontech",
              children: [
                {
                  name: "1. Datasheet HYPON - (15-20-25) kW",
                  file: "pdf",
                  link: "1. Datasheets/DEYE/",
                },
                {
                  name: "2. Datasheet HYPON - (15-20-25-30) kW - LV",
                  file: "pdf",
                  link: "1. Datasheets/DEYE/",
                },
                {
                  name: "3. Termo de Garantia HYPONTECH Português",
                  file: "pdf",
                  link: "1. Datasheets/DEYE/",
                },
              ],
            },
            {
              name: "Irrigasol",
              children: [
                {
                  name: "Datasheet Irrigasol",
                  file: "pdf",
                  link: "1. Datasheets/Irrigasol/",
                },
                {
                  name: "Termo de garantia",
                  file: "pdf",
                  link: "1. Datasheets/Irrigasol/",
                },
              ],
            },
            {
              name: "Leveros",
              children: [
                {
                  name: "1. Datasheet LEVEROS - 3.0 kW",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
                {
                  name: "2. Datasheet LEVEROS - (5.0-6.5) kW",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
                {
                  name: "3. Datasheet LEVEROS - 8.0 kW",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
                {
                  name: "4. Datasheet LEVEROS - (15-20-25) kW",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
                {
                  name: "5. Datasheet LEVEROS - (30-40-50) kW",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
                {
                  name: "6. Datasheet LEVEROS - (15-20-25-30) kW - LV",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
                {
                  name: "7. Termo de Garantia LEVEROS",
                  file: "pdf",
                  link: "1. Datasheets/Leveros/",
                },
              ],
            },
            {
              name: "Solis",
              children: [
                {
                  name: "1. Datasheet SOLIS - 3.0 kW - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "2. Datasheet SOLIS - (4.0-5.0) kW - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "2. Datasheet SOLIS - (4.0-5.0) kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "3. Datasheet SOLIS - (7.0-8.0-10.0) 4G kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "3. Datasheet SOLIS -(7-8-10) kW - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "4. Datasheet SOLIS -(7-7,7) kW - 5G",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "5. Datasheet SOLIS - (15-20) kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "5. Datasheet SOLIS -(12-15-20) kW - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "6. Datasheet SOLIS - 30 kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "6. Datasheet SOLIS -(25-30-40) kW - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "7. Datasheet SOLIS - (50-60) kW -  HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "7. Datasheet SOLIS - (50-60) kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "8. Datasheet SOLIS - 75 kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "9. Datasheet SOLIS - (100-110) kW - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "9. Datasheet SOLIS - 100 kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "10. Datasheet SOLIS - 255 kW",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "11. Datasheet SOLIS - (15-20) kW - LV",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "11. Datasheet SOLIS -(15-20-23) kW - LV - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "12. Datasheet SOLIS - (25-30) kW - LV",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "12. Datasheet SOLIS - (25-30, 37,5) kW - LV - HC",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "13. Datasheet SOLIS - (50-60) kW - LV",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                },
                {
                  name: "Termo Garantia_SOLIS_português",
                  file: "pdf",
                  link: "1. Datasheets/Solis/",
                }
              ],
            },
            {
              name: "SSM",
              children: [
                {
                  name: "CERTIFICADO-GARANTIA-GERAL",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Cerâmica",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Clamp Final",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Clamp Intermediário",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET FIBRO-MADEIRA",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET FIBRO-METAL",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Kalhetão",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET KIT JUNÇÃO",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Laje",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Mini trilho 500mm LONG (Micro)",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Mini trilho 500mm SHORT (string)",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET Perfil 2400mm",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET_Solo_8MOD",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
                {
                  name: "DATASHEET_Solo_16MOD",
                  file: "pdf",
                  link: "1. Datasheets/SSM/",
                },
              ],
            },
            {
              name: "Sunova",
              children: [
                {
                  name: "1. 505W - Mono PERC",
                  file: "pdf",
                  link: "1. Datasheets/Sunova/",
                },
                {
                  name: "2. 550W - Mono PERC",
                  file: "pdf",
                  link: "1. Datasheets/Sunova/",
                },
              ],
            },
            {
              name: "Znshine",
              children: [
                {
                  name: "1. 545W - Mono PERC",
                  file: "pdf",
                  link: "1. Datasheets/Znshine/",
                },
                 {
                  name: "2. 540W",
                  file: "pdf",
                  link: "1. Datasheets/Znshine/",
                },
              ],
            },
          ],
        },
        {
          name: "2. Manual de Instalação",
          children: [
            {
              name: "Canadian Solar",
              children: [
                {
                  name: "1 - Instalação (3-5) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Canadian Solar/",
                },
                {
                  name: "2 - Instalação (7-9) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Canadian Solar/",
                },
                {
                  name: "3 - Instalação (15-20) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Canadian Solar/",
                },
                {
                  name: "4 - Instalação (25-30) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Canadian Solar/",
                },
                {
                  name: "5 - Instalação 75 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Canadian Solar/",
                },
                {
                  name: "Manual_Substituição_Conectores",
                  file: "pdf",
                  link: "2. Manual de Instalação/Canadian Solar/",
                },
              ],
            },
            {
              name: "DEYE",
              children: [
                {
                  name: "Manual do microinversor",
                  file: "pdf",
                  link: "2. Manual de Instalação/DEYE/",
                },
              ],
            },
            {
              name: "Hypontech",
              children: [
                {
                  name: "1 - Manual Inversor 3.0 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Hypontech/",
                },
                {
                  name: "2 - Manual Inversor (5.0 - 6.5) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Hypontech/",
                },
                {
                  name: "3 - Manual Inversor 8 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Hypontech/",
                },
                {
                  name: "4 - Manual Inversor (15-20-25) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Hypontech/",
                },
                 {
                  name: "5 - Manual Inversor (30-40-50) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Hypontech/",
                },
                {
                  name: "6 - Manual Inversor (15-20-25-30) kW - LV",
                  file: "pdf",
                  link: "2. Manual de Instalação/Hypontech/",
                },
              ],
            },
            {
              name: "Irrigasol",
              children: [
                {
                  name: "Manual de Instalação - Irrigasol V2.1",
                  file: "pdf",
                  link: "2. Manual de Instalação/Irrigasol/",
                },
              ],
            },
            {
              name: "Leveros",
              children: [
                {
                  name: "1. Instalação LEVEROS - 3 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Leveros/",
                },
                {
                  name: "2. Instalação LEVEROS - (5.0-6.5) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Leveros/",
                },
                {
                  name: "3. Instalação LEVEROS - 8.0 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Leveros/",
                },
                {
                  name: "4. Instalação LEVEROS - (15-20-25) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Leveros/",
                },
                {
                  name: "5. Instalação LEVEROS - (15-20-25-30) LV kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Leveros/",
                },
                {
                  name: "6. Instalação LEVEROS - (30-40-50) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Leveros/",
                },
              ],
            },
            {
              name: "Solis",
              children: [
                {
                  name: "1. Instalação SOLIS - 3 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "2. Instalação SOLIS - (4,0-5,0) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "3. Instalação SOLIS - (7,0-8,0-10) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "4. Instalação SOLIS - (15-20) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "5. Instalação SOLIS - (25-30) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "6. Instalação SOLIS - (40-60) kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "7. Instalação SOLIS - 75 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "8. Instalação SOLIS - (15-20) kWLV",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "9. Instalação SOLIS - (25-30-50-60) kWLV",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
                {
                  name: "10. Instalação SOLIS - 255 kW",
                  file: "pdf",
                  link: "2. Manual de Instalação/Solis/",
                },
              ],
            },
          ],
        },
        {
          name: "3. Políticas",
          children: [
            {
              name: "Política Comercial",
              children: [
                {
                  name: "Política comercial - Leveros Solar",
                  file: "pdf",
                  link: "3. Políticas/Política Comercial/",
                },
              ],
            },
            {
              name: "Política de Garantia",
              children: [
                {
                  name: "Política de Garantias - Leveros Solar",
                  file: "pdf",
				  link: "3. Políticas/Política de Garantia/",
                },
              ],
            },
            {
              name: "Política de Trocas e Devoluções",
              children: [
                {
                  name: "Política de Troca e Devoluções - Leveros Solar",
                  file: "pdf",
				  link: "3. Políticas/Política de Trocas e Devoluções/",
                },
              ],
            },
          ],
        },
        {
          name: "4. Certificados",
          children: [
            {
              name: "Canadian Solar",
              children: [
                {
                  name: "1- Certificado (3-5-7-9) kW",
                  children: [
                    {
                      name: "1 - CERTIFICADO (3-5-7-9) kW",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/1- Certificado (3-5-7-9) kW",
                    },
                  ],
                },
                {
                  name: "2 - CERTIFICADOS (15-20) kW",
                  children: [
                    {
                      name:
                        "Canadian-Solar_Certificate_Inverter_5-20KW-3ph_IEC62109",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/2 - CERTIFICADOS (15-20) kW",
                    },
                    {
                      name: "CSI_cerificate_IEC-61727IEC-62116_3P5-20K-4G",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/2 - CERTIFICADOS (15-20) kW",
                    },
                    {
                      name: "Declaração-de-Conformidade-12",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/2 - CERTIFICADOS (15-20) kW",
                    },
                  ],
                },
                {
                  name: "3 - CERTIFICADOS (25-30) kW",
                  children: [
                    {
                      name:
                        "Canadian-Solar_Certificate_Inverter_NEW-25-40KW-400V_IEC62116-61727",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/3 - CERTIFICADOS (25-30) kW",
                    },
                    {
                      name:
                        "Canadian-Solar_Certificate_Inverter_NEW-25-50KW-5G_IEC62109",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/3 - CERTIFICADOS (25-30) kW",
                    },
                    {
                      name: "Declaração-de-Conformidade-12",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/3 - CERTIFICADOS (25-30) kW",
                    },
                  ],
                },
                {
                  name: "4 - CERTIFICADOS 75 kW",
                  children: [
                    {
                      name:
                        "CSI_certificate_IEC-61727IEC-62116_50-60K-LV-5G75-125K-5G-1",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/4 - CERTIFICADOS 75 kW",
                    },
                    {
                      name:
                        "CSI_certificate_IEC-62109-1-2EN-62109-1-2_50-60K-LV-5G75-125K-5G_TUV-Mark-1",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/4 - CERTIFICADOS 75 kW",
                    },
                    {
                      name: "Declaração-de-Conformidade-12",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/4 - CERTIFICADOS 75 kW",
                    },
                  ],
                },
                {
                  name: "5 - CERTIFICADOS 15 kW - LV",
                  children: [
                    {
                      name: "Declaração-de-Conformidade-12 (1)",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/5 - CERTIFICADOS 15 kW - LV",
                    },
                    {
                      name: "IEC61727-IEC62116-50448972-001",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/5 - CERTIFICADOS 15 kW - LV",
                    },
                    {
                      name: "IEC62109-CSI-TUV-Rheinland_CSI-15-20KTL-GI-LFL",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/5 - CERTIFICADOS 15 kW - LV",
                    },
                  ],
                },
                {
                  name: "6 - CERTIFICADOS 20 kW - LV",
                  children: [
                    {
                      name: "Declaração-de-Conformidade-12",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/6 - CERTIFICADOS 20 kW - LV",
                    },
                    {
                      name: "IEC61727-IEC62116-50448972-001-1",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/6 - CERTIFICADOS 20 kW - LV",
                    },
                    {
                      name: "IEC62109-CSI-TUV-Rheinland_CSI-15-20KTL-GI-LFL-1",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/6 - CERTIFICADOS 20 kW - LV",
                    },
                  ],
                },
                {
                  name: "7 - CERTIFICADOS 25 kW - LV",
                  children: [
                    {
                      name: "Declaração-de-Conformidade-12",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/7 - CERTIFICADOS 25 kW - LV",
                    },
                    {
                      name: "IEC61727-IEC62116-50448977-001",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/7 - CERTIFICADOS 25 kW - LV",
                    },
                    {
                      name:
                        "IEC62109-25-60k-Cert-20180702_701261802501-01_Canadian_B",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/7 - CERTIFICADOS 25 kW - LV",
                    },
                  ],
                },
                {
                  name: "8 - CERTIFICADOS 30 kW - LV",
                  children: [
                    {
                      name:
                        "AK-50432856-0001-Canadian-20-40k-IEC61000-3-12-_Cert-2",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/8 - CERTIFICADOS 30 kW - LV",
                    },
                    {
                      name: "Declaração-de-Conformidade-12",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/8 - CERTIFICADOS 30 kW - LV",
                    },
                    {
                      name: "IEC61727-IEC62116-50448977-001-1",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/8 - CERTIFICADOS 30 kW - LV",
                    },
                    {
                      name:
                        "IEC62109-25-60k-Cert-20180702_701261802501-01_Canadian_B-1",
                      file: "pdf",
					  link: "4. Certificados/Canadian Solar/8 - CERTIFICADOS 30 kW - LV",
                    },
                  ],
                },
              ],
            },
            {
              name: "DEYE",
              children: [
                {
                  name: "3 - CERTIFICADO  DEYE - 5 kW",
                  file: "pdf",
				  link: "4. Certificados/DEYE",
                },
                {
                  name: "5 - CERTIFICADO  DEYE - (6-10-12-15-20) kW",
                  file: "pdf",
				  link: "4. Certificados/DEYE",
                },
                  {
                  name: "6 - CERTIFICADO  DEYE - (30-50) kW",
                  file: "pdf",
				  link: "4. Certificados/DEYE",
                },
                {
                  name: "7 - CERTIFICADO DEYE - 75 kW",
                  file: "pdf",
				  link: "4. Certificados/DEYE",
                },
                 {
                  name: "8 - CERTIFICADO DEYE - (15-20-25-30) kW - LV",
                  file: "pdf",
				  link: "4. Certificados/DEYE",
                },
                {
                  name: "13 - CERTIFICADO DEYE - MICRO 2000 W",
                  file: "pdf",
				  link: "4. Certificados/DEYE",
                },
              ],
            },
            {
              name: "Hypontech",
              children: [
                {
                  name:
                    "Registro INMETRO HPK-1500D HPK-3000D HPS-5000D HPS-6500D HPS-8000D",
                  file: "png",
				  link: "4. Certificados/Hypontech",
                },
              ],
            },
            {
              name: "Leveros",
              children: [
                {
                  name: "Inversores Leveros - (15-20-25) kW",
                  children: [
                    {
                      name: "1. Certificado IEC 62116 e IEC61727 - (15-20-25) kW",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (15-20-25) kW"
                    },
                    {
                      name: "2. Certificado IEC62109-1 e IEC 62109-2 - (15-20-25) kW",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (15-20-25) kW"
                    },
                     {
                      name: "3. EU-Declaration-of-Conformity_HPT-15K-17K-20K-25K",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (15-20-25) kW"
                    },
                  ],
                    
                },
                 {
                  name: "Inversores Leveros - (15-20-25) kW - LV",
                  children: [
                    {
                      name: "1. Certificado IEC 62116 - (15-20-25-30) kW - LV",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (15-20-25) kW - LV"
                    },
                    {
                      name: "2. Certificado IEC 61000 - (15-20-25-30) kW - LV",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (15-20-25) kW - LV"
                    },
                     {
                      name: "3. EU-Declaration-of-Conformity_HPT-15K-17K-20K-25K",
                      file: "pdf",
                      link:"4.  Certificados/Leveros/Inversores Leveros - (15-20-25) kW - LV"
                    },
                    ],
                 },
                 {
                  name: "Inversores Leveros - (30-40-50) kW",
                  children: [
                    {
                      name: "1. Certificado IEC 60068 - (30-40-50) kW",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (30-40-50) kW"
                    },
                    {
                      name: "2. Certificado IEC 62116 e IEC61727 - (30-40-50) kW",
                      file: "pdf",
                      link:"4. Certificados/Leveros/Inversores Leveros - (30-40-50) kW"
                    },
                     {
                      name: "3. Certificado IEC62109-1 e IEC 62109-2 - (30-40-50) kW",
                      file: "pdf",
                      link:"4.  Certificados/Leveros/Inversores Leveros - (30-40-50) kW"
                    },
                    {
                      name: "4. Certificado IEC 61000 - (30-40-50) kW",
                      file: "pdf",
                      link:"4.  Certificados/Leveros/Inversores Leveros - (30-40-50) kW"
                    },
                    
                    ],
                 },
                {
                  name: "LEVEROS - HPK-3000",
                  file: "png",
				  link: "4. Certificados/Leveros",
                },
                {
                  name: "LEVEROS - HPK-8000",
                  file: "png",
				  link: "4. Certificados/Leveros",
                },
                {
                  name: "LEVEROS - HPS-5000 - HPS-6500",
                  file: "png",
				  link: "4. Certificados/Leveros",
                },
              ],
            },
            {
              name: "Solis",
              children: [
                {
                  name: "Alta Corrente",
                  children: [
                    {
                      name: "1 - CERTIFICADO SOLIS - 3 kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "2 - CERTIFICADO SOLIS - 4 kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "3 - CERTIFICADO SOLIS - 5 kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "4 - CERTIFICADO SOLIS -(12-15-20) kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "4 - CERTIFICADO SOLIS - 7 kW HC",
                      file: "jpeg",
					  link: "4 - CERTIFICADO SOLIS - 7 kW HC.jpeg",
                    },
                    {
                      name: "5 - CERTIFICADO SOLIS -(25-30-40) kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "5 - CERTIFICADO SOLIS - 8 kW HC",
                      file: "jpeg",
					  link: "5 - CERTIFICADO SOLIS - 8 kW HC",
                    },
                    {
                      name: "6 - CERTIFICADO SOLIS -(50-60) kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "6 - CERTIFICADO SOLIS - 10 kW HC",
                      file: "jpeg",
					  link: "6 - CERTIFICADO SOLIS - 10 kW HC",
                    },
                    {
                      name: "7 - CERTIFICADO SOLIS -(100-110) kW HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "8 - CERTIFICADO SOLIS -(15-20-23) kW LV HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                    {
                      name: "9 - CERTIFICADO SOLIS -(50-60) kW LV HC",
                      file: "pdf",
					  link: "4. Certificados/Solis/Alta Corrente",
                    },
                  ],
                },
                {
                  name: "1 - CERTIFICADO SOLIS - 3 kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "2 - CERTIFICADO SOLIS - 4 kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "3 - CERTIFICADO SOLIS  - 5 kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "4 - CERTIFICADO SOLIS  - 7 kW - 5G",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "5 - CERTIFICADO SOLIS  - 8 kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "6 - CERTIFICADO SOLIS  - 10 kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "7 - CERTIFICADO SOLIS - (15-20) kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "8 - CERTIFICADO SOLIS - (25-30-40) kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "9 - CERTIFICADO SOLIS - (50-60) kW",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "10 - CERTIFICADO SOLIS  - (75-100) kW-5G",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "11 - CERTIFICADO SOLIS - (15-20) kW LV",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "12 - CERTIFICADO SOLIS - (25-30)kW LV",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
                {
                  name: "13 - CERTIFICADO SOLIS - 7,7 kW - 5G",
                  file: "pdf",
				  link: "4. Certificados/Solis",
                },
              ],
            },
          ],
        },
        {
          name: "5. Manuais de Configuração",
          children: [
            {
              name: "Canadian Solar",
              children: [
                {
                  name: "Alteração-de-parametros-CSI-NG-",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Canadian Solar",
                },
                {
                  name:
                    "Configuração (pelo APP) em menos de 02 min. do Datalogger Prata no CSI Cloud Pro.",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Canadian Solar",
                },
                {
                  name: "Monitoramento-Completo-Inversores-CSI-NG (1)",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Canadian Solar",
                },
                {
                  name: "Monitoramento-Completo-GI-CSI- DATALOGGER PRATA",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Canadian Solar",
                },
              ],
            },
            {
              name: "DEYE",
              children: [
                {
                  name: "Guia Solarman Business Deye Brasil.pdf",
                  file: "pdf",
				  link: "5. Manuais de Configuração/DEYE",
                },
                {
                  name: "Manual de monitoramento do microinversor",
                  file: "pdf",
				  link: "5. Manuais de Configuração/DEYE",
                },
                {
                  name: "Procedimento quando não encontra rede wifi",
                  file: "mp4",
				  link: "5. Manuais de Configuração/DEYE",
                },
              ],
            },
            {
              name: "Hypontech",
              children: [
                {
                  name: "Alteração de tensão CA via app",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Hypontech",
                },
                {
                  name: "Baixando dados em gráfico no Hiportal",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Hypontech",
                },
                {
                  name: "Criação de Planta Cliente final APP",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Hypontech",
                },
                {
                  name: "HiPortal App_ Inverter Internet Configuration - iOS",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Hypontech",
                },
                {
                  name: "Hypontech - Configuração do Wi-Fi (Android)",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Hypontech",
                },
                {
                  name: "Problemas de Conexão",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Hypontech",
                },
                {
                  name: "Status de erro",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Hypontech",
                },
              ],
            },
            {
              name: "Irrigasol",
              children: [
                {
                  name: "1 - Manual do aplicativo Irrigasol",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Irrigasol",
                },
                {
                  name:
                    "Configuração e parametrização do Inversor Solar Irrigasol",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Irrigasol",
                },
                {
                  name: "Procedimento de envio de dados para análise",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Irrigasol",
                },
              ],
            },
            {
              name: "Leveros",
              children: [
                {
                  name: "01 Manual_Monitoramento_Wifi_Leveros",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Leveros",
                },
                {
                  name: "02 Criação_Usuário_Cliente_Final_Web_Leveros",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Leveros",
                },
                {
                  name: "Alteração de tensão CA Remoto APP",
                  file: "png",
				  link: "5. Manuais de Configuração/Leveros",
                },
                {
                  name: "Alteração de tensão CA Remoto WEBSITE",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Leveros",
                },
                {
                  name: "Criando login de cliente final",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Leveros",
                },
                {
                  name: "Criando planta de cliente final",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Leveros",
                },
                {
                  name: "Inserindo datalogger na planta",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Leveros",
                },
              ],
            },
            {
              name: "Solis",
              children: [
                {
                  name: "GUIA RÁPIDO DE USUÁRIO SOLISCLOUD (1)",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Solis",
                },
                {
                  name:
                    "Monitoramento Solis - adicionando plantas na conta profissional",
                  file: "mov",
				  link: "5. Manuais de Configuração/Solis",
                },
                {
                  name:
                    "Sistema de monitoramento Ginlong Solis (Brasil) -Website",
                  file: "mp4",
				  link: "5. Manuais de Configuração/Solis",
                },
                {
                  name:
                    "1 - GUIA DE USUARIO NOVO DATALOGGER SOLIS CLOUD",
                  file: "pdf",
				  link: "5. Manuais de Configuração/Solis",
                },
              ],
            },
          ],
        },
        {
          name: "6. Treinamentos",
          children: [
            {
              name: "Detecção de Problemas",
              children: [
                {
                  name:
                    "Problemas na expansão de sistemas FV E Corrente Reversa1",
                  file: "pdf",
				  link: "6. Treinamentos/Detecção de Problemas",
                },
                {
                  name: "Treinamento Problemas em Usinas - Inversores",
                  file: "pdf",
				  link: "6. Treinamentos/Detecção de Problemas",
                },
                {
                  name: "Treinamento Problemas em Usinas - Módulos FV",
                  file: "pdf",
				  link: "6. Treinamentos/Detecção de Problemas",
                },
              ],
            },
            {
              name: "Iniciar no setor fotovoltaico",
              children: [
                {
                  name: "Diferenças entre inversor e micro inversor",
                  file: "pdf",
				  link: "6. Treinamentos/Iniciar no setor fotovoltaico",
                },
                {
                  name: "O que você precisa para iniciar no setor fotovoltaico",
                  file: "pdf",
				  link: "6. Treinamentos/Iniciar no setor fotovoltaico",
                },
                {
                  name: "Treinamento Inversores String",
                  file: "pdf",
				  link: "6. Treinamentos/Iniciar no setor fotovoltaico",
                },
              ],
            },
          ],
        },
      ],
    };
  },

  async created() {
    this.linkDaPagina = window.location.href;
  },

  metaInfo() {
    return {
      title: "Central de Downloads | Leveros Integra",
      meta: [
        {
          name: "description",
          content:
            "Encontre de forma rápida e simples, todos os manuais do usuário, manuais de instruções e uso, certificado de garantia etc dos produtos.",
        },
        { name: "robots", content: "noindex,nofollow" },
        { name: "country", content: "BRA" },
        { name: "currency", content: "R$" },
        { name: "author", content: "Leveros Integra" },
        { name: "copyright", content: "Leveros Integra" },
        {
          property: "og:title",
          content: "Catálago e Manuais | Leveros Integra",
        },
        {
          property: "og:description",
          content:
            "Encontre de forma rápida e simples, todos os manuais do usuário, manuais de instruções e uso, certificado de garantia etc dos produtos.",
        },
        { property: "og:site_name", content: "Leveros Integra" },
        { property: "og:author", content: "Leveros Integra" },
        { property: "og:url", content: `${this.linkDaPagina}` },
        { property: "og:type", content: "company" },
      ],
      link: [{ rel: "canonical", href: `${this.linkDaPagina}` }],
    };
  },
  methods: {
    abrirJanela(link) {
      window.open(this.baseUrlDownload + link);
    },
  },
  components: {
    HeaderPanel,
    NavbarPanel,
  },
};
</script>

<style lang="scss" scoped>
.panel {
  display: grid;
  grid-template-areas:
    "header header header"
    "main main main";
  grid-template-columns: 0.7fr 3fr;

  @media (max-width: 440px) {
    grid-template-areas:
      "header header header"
      "main main main";
  }
}

.headerPanel {
  grid-area: header;
}

.navbarPanel {
  grid-area: navbar;
}

.mainCatalogs {
  grid-area: main;
}
</style>
